import { DockerCleanupFormValues, DockerCleanupPolicyPayload } from './types';
import { parseDuration } from './duration';

export function buildDockerCleanupPayload(
  formValues: DockerCleanupFormValues
): DockerCleanupPolicyPayload {
  return {
    cleanupInterval: {
      value: parseDuration(formValues.cleanupInterval),
      enforce: true,
    },
    cleanOldImages: { value: formValues.cleanOldImages, enforce: true },
    imageMaximumGCAge: {
      value: parseDuration(formValues.imageMaximumGCAge),
      enforce: formValues.cleanOldImages,
    },
    cleanImagesAtStorageLimit: {
      value: formValues.cleanImagesAtStorageLimit,
      enforce: true,
    },
    highThresholdPercent: {
      value: formValues.highThresholdPercent,
      enforce: formValues.cleanImagesAtStorageLimit,
    },
    lowThresholdPercent: {
      value: formValues.lowThresholdPercent,
      enforce: formValues.cleanImagesAtStorageLimit,
    },
    clearBuildCache: {
      value: formValues.clearBuildCache,
      enforce: true,
    },
    minAge: { value: parseDuration(formValues.minAge), enforce: true },
    maxImagesPerInterval: {
      value: formValues.maxImagesPerInterval,
      enforce: formValues.maxImagesPerInterval > 0,
    },
    excludedImages: {
      value: formValues.excludedImages.map((s) => s.trim()).filter(Boolean),
      enforce: formValues.excludedImages.some((s) => s.trim().length > 0),
    },
  };
}
